<template src="../CMSPage/template.html"></template>
<style src="../CMSPage/page.scss" lang="scss"></style>

<script>
import { mapActions, mapState } from 'vuex'
import cmsPageMixin from '@/mixins/cmsPageMixin'

export default {
  name: 'CMSPreview',
  mixins: [cmsPageMixin],
  computed: {
    ...mapState('pages', [ 'page' ]),
    ...mapState('auth', { activeUser: 'user' }),
  },
  methods: {
    ...mapActions('pages', ['getPreview']),
    requestData() {
      this.getPreview(this.$route.params.id).then(_ => {
        this.checkVisibility()
        if (!this.limitedContent) {
          if (!Object.prototype.hasOwnProperty.call(this.page, 'likes_allowed') || this.page.likes_allowed) {
            this.fetchLikes()
          }
          if (this.page.comments_allowed) {
            this.fetchComments()
          }
        }
        this.isArticle = this.page.meta && this.page.meta.type && this.page.meta.type === 'article'
      })
    },
  },
}

</script>
